import { render } from "./TheTaskFormPage.vue?vue&type=template&id=ef45fc54"
import script from "./TheTaskFormPage.vue?vue&type=script&lang=js"
export * from "./TheTaskFormPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__